

























import type {PeriodeMetOnderbrekingen} from "../../types/opdrachten/PeriodeMetOnderbrekingen";
import type {Periode} from "../../types/opdrachten/Periode";
import type {PeriodeIcon} from "./periode-icon";

import Vue from "vue";
import OnderbrekingCardContent from "./OnderbrekingCardContent.vue";
import EhrCard from "./EhrCard.vue";
import SectionCard from "../interface/SectionCard.vue";

export default Vue.extend({
  name: "PeriodesMetOnderbrekingen",
  components: {
    SectionCard,
    EhrCard,
    OnderbrekingCardContent,
  },
  props: {
    periodesMetOnderbrekingen: {
      type: Array as () => PeriodeMetOnderbrekingen[],
      required: true
    },
  },
  methods: {
    periodeTitle({ van, tot }: Periode): string {
      if (!tot) return `Vanaf ${van}`;
      return van === tot ? van : `${van} - ${tot}`;
    },
    periodeIcon(periode: Periode): PeriodeIcon {
      const periodeIcons: {[key: string]: PeriodeIcon} = {
        'Verleden': 'chevrons-left',
        'Heden': 'tasks',
        'Toekomst': 'chevrons-right',
      };
      return periodeIcons[periode.chronologie];
    }
  }
});
